import * as Sentry from '@sentry/browser'
import * as React from 'react'
import GenericError from '../pages/genericError'

interface ErrorBoundaryProps {
  children?: React.ReactNode | undefined
}

interface ErrorBoundaryState {
  hasError: boolean
}

class ErrorBoundary extends React.Component<
  ErrorBoundaryProps,
  ErrorBoundaryState
> {
  // See https://reactjs.org/blog/2017/07/26/error-handling-in-react-16.html#introducing-error-boundaries
  constructor(props: {}) {
    super(props)
    this.state = { hasError: false }
  }

  public componentDidCatch(error: any, info: any) {
    this.setState({ hasError: true })
    Sentry.withScope((scope: any) => {
      scope.setExtras(info)
      Sentry.captureException(error)
    })
  }

  public render() {
    if (this.state.hasError) {
      return <GenericError />
    }
    return this.props.children
  }
}

export default ErrorBoundary
